import React from 'react';
import {
  ArrowRight,
  RefreshCw,
  CheckSquare,
  XCircle,
  Activity,
} from 'lucide-react';
import { getEventMeta, formatRelativeTime } from '../utils/format';
import styles from './ActivityLog.module.css';

const ICONS = {
  'arrow-right': ArrowRight,
  'refresh-cw': RefreshCw,
  'check-square': CheckSquare,
  'x-circle': XCircle,
  activity: Activity,
  eye: Activity,
  'check-circle': CheckSquare,
  'alert-circle': XCircle,
};

function ActivityEvent({ event }) {
  const meta = getEventMeta(event.event_type);
  const Icon = ICONS[meta.icon] || Activity;

  return (
    <article className={styles.event}>
      <div
        className={styles.eventIcon}
        style={{
          backgroundColor: `${meta.color}12`,
          color: meta.color,
        }}
      >
        <Icon size={14} aria-hidden="true" />
      </div>
      <div className={styles.eventContent}>
        <p className={styles.eventDescription}>{event.description}</p>
        <div className={styles.eventMeta}>
          <span className={styles.eventTimestamp}>{formatRelativeTime(event.timestamp)}</span>
          <span className={styles.eventActors}>
            {event.source_role && event.target_role
              ? `${event.source_role} → ${event.target_role}`
              : event.actor_role || event.actor || ''}
          </span>
        </div>
      </div>
      {event.branch && (
        <span className={styles.eventBranch}>{event.branch}</span>
      )}
    </article>
  );
}

export function ActivityLog({ events }) {
  return (
    <section className={styles.log} aria-label="Activity log" aria-live="polite">
      <div className={styles.toolbar}>
        <h2 className={styles.title}>Activity Log</h2>
        <span className={styles.count}>{events.length} events</span>
      </div>

      <ul className={styles.list}>
        {events.map((event) => (
          <li key={event.id}>
            <ActivityEvent event={event} />
          </li>
        ))}
      </ul>

      {events.length === 0 && (
        <div className={styles.empty}>
          <Activity size={48} className={styles.emptyIcon} aria-hidden="true" />
          <p className={styles.emptyTitle}>No recent activity</p>
          <p className={styles.emptySubtitle}>Events will appear here as they happen.</p>
        </div>
      )}
    </section>
  );
}
